import { useCallback, useState } from 'react';

const useFailures = () => {
  const [failedIdentifiers, setFailedIdentifiers] = useState<Set<string>>(
    new Set(),
  );

  const markFailed = useCallback((...identifiers: string[]) => {
    setFailedIdentifiers(prev => {
      const next = new Set(prev);
      identifiers.forEach(id => next.add(id));
      return next;
    });
  }, []);

  const markSucceeded = useCallback((...identifiers: string[]) => {
    setFailedIdentifiers(prev => {
      if (!identifiers.some(id => prev.has(id))) return prev;
      const next = new Set(prev);
      identifiers.forEach(id => next.delete(id));
      return next;
    });
  }, []);

  const reset = (...identifier: string[]) => {
    markSucceeded(...identifier);
  };

  return { failedIdentifiers, markFailed, markSucceeded, reset };
};

export default useFailures;
